import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Radio,
    RadioGroup,
    FormControlLabel,
} from '@mui/material';
import { useRemoveDriverFromOrderMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { toast } from 'react-toastify';
import { Button } from "react-bootstrap";
import errorHandler from '../../hooks/ErrorHanlder';

const RemoveDriver = (props) => {
    const order = props.removeOrder || props.removeOrderTrip || null;
    const [selectedValue, setSelectedValue] = useState('');
    const [removeDriverFromOrder] = useRemoveDriverFromOrderMutation();
    const handleRadioChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const nameMap = {
        pickup: 'pickUpDriver',
        pickupxdock: 'pxDock',
        linehauler: 'lineHauler',
        deliveryxdock: 'dxDock',
        delivery: 'deliveryDriver',
    }

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }

    const handleConfirm = async () => {
        const body = {
            orderId: order.orderID,
            driverAssignmentType: selectedValue,
            orderNumber: order.orderNumber,
            divisionId: props.divisionId,
            driverNumber: order[nameMap[selectedValue]],
        }
        try {
            await removeDriverFromOrder(body).unwrap();
            toast.success('Driver removed successfully', { position: 'top-center' });
            props.setRemoveDriverPopup(false);
            props.getAllOpenTripOrders(props.divisionId);
            if (props.selectedTrip) {
                props.refetchTripOrders()
                props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId });
            }
        } catch (error) {
            errorHandler(error);
        }
    };

    return (
        <Dialog open={props.removeDriverPopup} onClose={() => props.setRemoveDriverPopup(false)}>
            <DialogTitle id="alert-dialog-title" style={{ backgroundColor: '#bf2527', color: 'white', display: 'flex', alignItems: 'center' }}>
                Select a Driver
            </DialogTitle>
            <DialogContent sx={{ minWidth: "400px" }} className='mt-2'>
                <RadioGroup value={selectedValue} onChange={handleRadioChange}>
                    {order?.pickUpDriver &&
                        <FormControlLabel value="pickup" control={<Radio />} label="Pickup" />
                    }
                    {order?.pxDock &&
                        <FormControlLabel value="pickupxdock" control={<Radio />} label="Pickup Crossdock" />
                    }
                    {order?.lineHauler &&
                        <FormControlLabel value="linehauler" control={<Radio />} label="Linehauler" />
                    }
                    {order?.dxDock &&
                        <FormControlLabel value="deliveryxdock" control={<Radio />} label="Delivery Crossdock" />
                    }
                    {order?.deliveryDriver &&
                        <FormControlLabel value="delivery" control={<Radio />} label="Delivery" />
                    }
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <div className='d-flex gap-3 p-3 justify-content-end'>
                    <Button style={{ width: "120px" }} onClick={() => props.setRemoveDriverPopup(false)} className="btn-secondary">
                        Cancel
                    </Button>
                    <Button style={{ width: "120px" }} onClick={handleConfirm} className="btn-primary">
                        Confirm
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default RemoveDriver;